<template>
  <div>
    <div class="notes-header">
      <h2>Notes</h2>
    </div>
    <div v-if="feedbackNotes" class="feedback-notes-container">
      <div v-for="(note, index) in feedbackNotes" :key="index" class="note">
        <div class="icons-container">
          <v-icon
            v-model="showEditIcon"
            size="11"
            class="edit-note-icon"
            @click="editExistNote(note, index)"
          >
            fas fa-pen
          </v-icon>
          <v-icon size="18" @click="removeNote(index)">
            close
          </v-icon>
        </div>
        <div>
          <span class="note-name">{{ getNoteCreatorName(note) }}: </span>
          <span>{{ formatDate(note._timestamp) }} - </span>
          <span class="note-text">{{ note.text }}</span>
        </div>
      </div>
      <hr class="mt-2">
    </div>
    <div class="feedback-note">
      <textarea
        ref="feedbackTextarea"
        v-model="noteText"
        class="feedback-note-body"
        placeholder="Start typing your note, press enter to add it"
        @keyup.enter="editingNote ? updateNote(editingNote) : addNote()"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    feedbackNotes: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    noteText: '',
    showEditIcon: true,
    editingNote: null,
    editingNoteIndex: null
  }),

  computed: {
    ...mapState('agent', ['agentData']),
    ...mapState('client', ['clientData', 'associatedAgent']),
    ...mapState('common', ['profileStatus']),
    ...mapState('feedback', ['feedbackNote']),

    agent() {
      return this.associatedAgent ? this.associatedAgent : this.agentData
    }
  },

  watch: {
    noteText(newValue) {
      this.setFeedbackNote({
        note: {
          ...this.editingNote,
          text: newValue,
          _creator:
            this.profileStatus === 'client'
              ? this.clientData._id
              : this.agent._id
        },
        index: this.editingNoteIndex
      })
    }
  },

  methods: {
    ...mapMutations('feedback', {
      setFeedbackNote: 'SET_FEEDBACK_NOTE'
    }),

    addFocus() {
      this.$refs.feedbackTextarea.focus()
    },

    addNote() {
      this.noteText = this.noteText.slice(0, -1)
      if (!this.noteText) return
      this.$emit('add-feedback-note', {
        text: this.noteText,
        _creator:
          this.profileStatus === 'client' ? this.clientData._id : this.agent._id
      })
      this.noteText = ''
      this.setFeedbackNote(null)
      this.$refs.feedbackTextarea.blur()
    },

    updateNote(note) {
      this.$emit('update-feedback-note', {
        note: {
          ...note,
          text: this.noteText,
          _creator:
            this.profileStatus === 'client'
              ? this.clientData._id
              : this.agent._id
        },
        index: this.editingNoteIndex
      })

      this.noteText = ''
      this.setFeedbackNote(null)
      this.editingNote = null
    },

    formatDate(date) {
      return moment(date).format('MM-DD-YYYY, h:mm a')
    },

    getNoteCreatorName(note) {
      const name =
        note._creator === this.agent._id
          ? this.agent.name
          : this.clientData.name
      return name
    },

    editExistNote(note, index) {
      this.noteText = note.text
      this.editingNote = note
      this.editingNoteIndex = index
      this.$refs.feedbackTextarea.focus()
    },

    removeNote(position) {
      this.$emit('remove-feedback-note', position)
    }
  }
}
</script>

<style lang="sass">
.feedback-note
  border: 1px solid $color-grey
  height: 128px
  width: 80%
  margin: 60px auto 24px
  position: relative
.feedback-note-body
  width: 100%
  height: 100%
  overflow: auto
  padding: 24px
  resize: none
.feedback-edit-icon, .edit-note-icon
  color: $hwayzBrandGold !important
.edit-note-icon
  padding-top: 2px
.feedback-notes-container span:not(:last-child)
  font-weight: bold
.feedback-notes-container .note-name
  text-transform: capitalize
.feedback-notes-container
  text-align: left
  width: 80%
  max-height: 350px
  overflow: auto
  margin: 24px auto 0
.feedback-notes-container .note
  position: relative
  padding-left: 17px
.notes-header h2
  font-size: 20px
  line-height: 37px
  font-weight: 400
  text-transform: capitalize
  color: #373737
.feedback-add-note-btn
  background-color: $hwayzBrandGold
  width: 150px
  height: 35px
  border-radius: 5px
  color: $hwayzWhite
  font-weight: 500
.feedback-notes-container .note
  display: flex
  flex-direction: row
.icons-container
  display: flex
  align-items: flex-start
  padding-top: 2px
</style>
